import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from "rxjs";
import { EventService } from "./core/services/event.service";
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'extranetv2';
  pendingCount = 0;

  isGlobalLoading = false;
  private loaderSubscription!: Subscription;
  private bookingSubscription!: Subscription;

  constructor(
    private eventService: EventService,
    private meta: Meta,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // remove any existing robots tag
    this.meta.removeTag('name="robots"');
    // add the appropriate robots tag
    this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });

    this.loaderSubscription = this.eventService.subscribe('globalLoader:show', () => {
      this.isGlobalLoading = true;
      this.cdr.detectChanges();
    });
    this.loaderSubscription.add(
      this.eventService.subscribe('globalLoader:hide', () => {
        this.isGlobalLoading = false;
        this.cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    if(this.bookingSubscription) {
      if (this.bookingSubscription) this.bookingSubscription.unsubscribe();
    }
  }
}
